module.exports = __webpack_public_path__ + "img/hardwareRouter6.41b51ff5.png";